var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height",attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"col-auto"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }